var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    fill: "none",
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M7 12.5v5.833M3.668 6.09v1.776c0 .173 0 .26-.017.343a.833.833 0 0 1-.074.211c-.039.075-.093.143-.201.279l-1.308 1.635c-.555.693-.832 1.04-.833 1.332 0 .253.115.494.314.652.228.182.672.182 1.56.182h7.785c.888 0 1.332 0 1.56-.182a.833.833 0 0 0 .314-.652c0-.292-.278-.639-.833-1.332l-1.308-1.635a1.762 1.762 0 0 1-.2-.279.832.832 0 0 1-.075-.211c-.017-.083-.017-.17-.017-.343V6.09c0-.096 0-.144.005-.191a.835.835 0 0 1 .024-.125c.013-.045.03-.09.066-.18l.84-2.099c.245-.612.368-.919.317-1.165a.834.834 0 0 0-.356-.525c-.21-.138-.54-.138-1.199-.138H3.97c-.66 0-.99 0-1.2.138a.833.833 0 0 0-.355.525c-.05.246.072.553.317 1.165l.84 2.1c.035.089.053.134.066.18.01.04.019.082.024.124.005.047.005.095.005.191Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon2);
export default __webpack_public_path__ + "static/media/pin-icon2.df90decda72af04996fe700009468a81.svg";
export { ForwardRef as ReactComponent };